import React, {useEffect, useState} from 'react';
import Frame from "../components/layout/Frame";
import {Col, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import {getCMFWListFIInfo, getSSList} from "../api/apiClient";
import {updateMarkerList} from "../common/CanvasUtils";
import Swal from "sweetalert2";
import PopUp from "../components/popUp/PopUp";
import SensorPopupBody from "./subPages/SensorPopupBody";
import FacilityFloorEquipmentSettingNameSearchBox
  from "../components/searchBoxs/FacilityFloorEquipmentSettingNameSearchBox";
import MarkerImagePanel from "../components/control/MarkerImagePanel";
import MarkerListPanel from "../components/control/MarkerListPanel";
import MarkerSensorListTable from "../components/control/MarkerSensorListTable";
import useAuth from "../hook/useAuth";

const ConfSensor = () => {

  const [stSensorSearch, setSensorSearch] = useState({
    fcltyCd: 0,
    floorCd: 0,
  });

  const [stBox, setBox] = useState({
    image_height: 0,
    image_width: 0,
    client_width: 794,
    client_height: 650,
  });

  useEffect(() => {
    console.log(stSensorSearch);
  }, [stSensorSearch])

  const [stFloorData, setFloorData] = useState({});

  const updateFloorData = () => {
    getCMFWListFIInfo(stSensorSearch.fcltyCd, stSensorSearch.floorCd).then(
        (res) => {
          if (res.data.data !== undefined) {
            setFloorData(res.data.data);
          }
        }
    )
  };

  const [stTableListEquip, setTableListEquip] = useState([]);

  const [stMarkerList, setMarkerList] = useState([]);


  /* 센서 목록 호출 */
  const getList = async (pageNum, pageSize,
                         searchAtdrcId, searchFcltyDtlNo,
                         searchFcltyLcNm, searchFcltyNo, searchRpeatNo,
                         searchSensorTy, searchSetupYn) => {
    let resp;
    try {
      resp = await getSSList(pageNum, pageSize,
          searchAtdrcId, searchFcltyDtlNo,
          searchFcltyLcNm, searchFcltyNo, searchRpeatNo,
          searchSensorTy, searchSetupYn);
    } catch (error) {
    }
    return resp;
  };

  const updateDeviceList = () => {
    // 미설정 장비 (현재 시설)
    getList(1, 1000,
        '', stSensorSearch.floorCd,
        '', stSensorSearch.fcltyCd, '',
        '', '').then((response) => {
      setTableListEquip(response.data.data.list);
    });
  };

  useEffect(() => {
    updateDeviceList();
    setMarkerList([]);
  }, [stFloorData])


  useEffect(() => {
    updateMarkerList(stTableListEquip, stMarkerList, setMarkerList);
  }, [stBox, stTableListEquip])

  const [stPopup, setPopup] = useState({visible: false});
  const showPopup = (e, id = 0, x = 0, y = 0, type = '1') => {

    if (id === 0) {
      if (stSensorSearch.fcltyCd !== '' && stFloorData.fclty_dtl_nm !== undefined) {
        setPopup({
          visible: true, isNew: true,
          fclty_cd: stSensorSearch.fcltyCd,
          fclty_dtl_no: stFloorData.fclty_dtl_no,
          fclty_dtl_nm: stFloorData.fclty_dtl_nm,
          x: x,
          y: y,
          sensor_ty: type
        });
      } else {
        // alert('시설 선택과 층 선택을 먼저 해주세요.')
        Swal.fire('시설명과 층을 선택해주세요.');
      }
    } else {
      setPopup({visible: true, id: id, isNew: false})
    }
  };

  const closePopup = (isUpdate = false) => {
    // console.log(isUpdate);
    // alert('닫기!');
    setPopup({visible: false});
    if (isUpdate) {
      updateDeviceList();
    }
  };

  const onKeyDown = (e) => {
    if (e.key === 'Delete') {
      if (stMarkerList) {
        // eslint-disable-next-line array-callback-return
        stMarkerList.map((elem) => {
          if (elem.selected) {
            console.log(elem);
            Swal.fire({
              title: `미설치로 변경하시겠습니까?`,
              text: `선택한 장비 ${elem.sensor_id}를 미설치로 변경합니다.`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: '확인',
              cancelButtonText: '취소'
            }).then((result) => {
              if (result.isConfirmed) {
                setMarkerList(
                    stMarkerList.map((mark) => {
                      return {
                        ...mark,
                        status: 'Normal',
                        x: (elem.id === mark.id) ? '' : mark.x,
                        y: (elem.id === mark.id) ? '' : mark.y,
                        setup_yn: (elem.id === mark.id) ? 'N' : mark.setup_yn,
                        isModified: (elem.id === mark.id) ? true : mark.isModified,
                      }
                    })
                )
                Swal.fire(
                    '변경하였습니다!',
                    '미설치 상태로 변경 완료.',
                    'success'
                )
              }
            })
                .catch((err) => {
                  Swal.fire(
                      err.response.data.message,
                      '',
                      'error'
                  );
                });
          }
        })
      }
    }
  };

  /*const [auth, setAuth] = useState("0");

  useEffect(() => {
    setAuth(sessionStorage.getItem("CURRENT_AUTH"));
  }, []);*/

  const auth = useAuth();
  console.log(auth);

  return (
      <Frame
          propIsActiveHeader={true}
          propIsActiveSidebar={true}
      >
        <Container fluid tabIndex={-1}
            // onKeyDown={onKeyDown}
        >
          <PopUp
              propShow={stPopup.visible}
              propSize={'lg'}
              setShow={closePopup}
              propTitle={stPopup.isNew ? '센서 등록' : '센서 수정'}
          >
            <SensorPopupBody
                propFcltyNm={stSensorSearch.fcltyNm}
                propFcltyCd={stSensorSearch.fcltyCd}
                propFloorNm={stFloorData.fclty_dtl_nm}
                propFloorNo={stFloorData.fclty_dtl_no}
                propID={stPopup.id}
                propIsNew={stPopup.isNew}
                propX={stPopup.x}
                propY={stPopup.y}
                propType={stPopup.sensor_ty}
                hClose={closePopup}
            />
          </PopUp>
          <Row className={"p-3"}>
            <Col md={12}>
              <Row>
                <Col md={12} className={"search-container py-2"}>
                  <FacilityFloorEquipmentSettingNameSearchBox
                      propSensorSearch={stSensorSearch}
                      setSensorSearch={setSensorSearch}
                      showPopup={showPopup}
                      propUpdate={updateFloorData}
                      propAuth={auth}
                  />
                </Col>
              </Row>

              <Row className={"mt-2 py-2"}>
                <Col md={8} className={"narrow-floor-plan-container p-2"}>
                  <MarkerImagePanel
                      propFloorName={stFloorData.fclty_dtl_nm}
                      propFloorData={stFloorData}
                      propUpdateList={updateDeviceList}
                      propMarkerList={stMarkerList}
                      setMarkerList={setMarkerList}
                      showPopup={showPopup}
                      propAuth={auth}
                  />
                </Col>

                {/*<Col md={3} className={"table-container p-2"}>*/}
                {/*  <MarkerListPanel*/}
                {/*      propTitle={'미설치 리스트 (현재 층)'}*/}
                {/*      propList={stTableListEquip}>*/}
                {/*    <MarkerSensorListTable*/}
                {/*        propMarkerList={stMarkerList}*/}
                {/*        setMarkerList={setMarkerList}*/}
                {/*        propSetupFilter={'N'}*/}
                {/*        showPopup={showPopup}*/}
                {/*    />*/}
                {/*  </MarkerListPanel>*/}
                {/*</Col>*/}

                <Col md={4} className={"table-container p-2"}>
                  <MarkerListPanel
                      propTitle={'설치 리스트 (현재 층)'}>
                    <MarkerSensorListTable
                        propMarkerList={stMarkerList}
                        setMarkerList={setMarkerList}
                        propSetupFilter={'Y'}
                        showPopup={showPopup}
                        propAuth={auth}
                    />
                  </MarkerListPanel>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Frame>
  );
};

export default ConfSensor;
